import { ClassYearNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: ClassYearNameFragment) {
	return Fields.name(instance.name);
}

/**
 * Returns the abbreviated name of the given instance. (Used for icons).
 */
export function abbreviatedName(instance: ClassYearNameFragment) {
	const instanceName = name(instance);
	const numberMatch = instanceName.match(/\d+/);
	const initials = instanceName
		.split(/\s+/)
		.filter((word) => !word.match(/\d+/))
		.map((word) => word.charAt(0).toUpperCase())
		.join("");

	if (numberMatch) {
		return initials + numberMatch[0];
	}

	return initials;
}
